// import { useEffect, useState } from 'react';
// import { getMessaging, getToken, onMessage } from 'firebase/messaging';
// import { notify } from '../Utils/toastify';
// import { NotificationFCM } from '../types';
// import { ToastNotification } from './ToastNotification';
// import { useSocket } from '../Pages/Chats/SocketContext';
// import { ROUTES } from '../helpers/contants';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { fetchNoticationList } from '../redux/notification.slice';
// import endPoints from '../api/endpoint';
// import { getApiCall, putApiCall } from '../api/methods';
// import { RootState, useAppSelector } from '../redux/store';
// import { messaging, getMessagingInstance } from '../Utils/firebaseConfig';
// import { ApiStatus } from '../types';

// const VAPID_KEY = process.env.FIREBASE_WEBPUSH_VAPID;

// const NotificationService = () => {
//   const dispatch = useDispatch();
//   const [token, setToken] = useState<string>('');
//   const [isInitialized, setIsInitialized] = useState<boolean>(false);
//   const [hasTriedToGetToken, setHasTriedToGetToken] = useState<boolean>(false);
//   const {
//     userData,
//     apiStatus,
//     token: loginToken,
//   } = useAppSelector((state: RootState) => state.auth);
//   const socketClient = useSocket();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Use the messaging instance from firebaseConfig.ts
//   const firebaseMessaging = getMessagingInstance();

//   // Initialize component
//   useEffect(() => {
//     setIsInitialized(true);
//   }, []);

//   // Function to send token to backend
//   const sendTokenToBackend = async (token: string) => {
//     if (!loginToken || !token) {
//       console.log('Skipping token send - missing requirements:', {
//         hasLoginToken: !!loginToken,
//         hasFCMToken: !!token,
//       });
//       return;
//     }

//     console.log('Sending FCM token to backend...');

//     return new Promise<void>((resolve, reject) => {
//       putApiCall(
//         endPoints.notification.updateDeviceTokenFCM + `?token=${token}`,
//         {},
//         (response: any) => {
//           console.log('✅ FCM token successfully sent to backend:', response);
//           resolve();
//         },
//         (error: any) => {
//           console.error('❌ Error sending FCM token to backend:', error);
//           reject(error);
//         },
//       );
//     });
//   };

//   // handle message
//   function handleMessage(payload: NotificationFCM) {
//     console.log('Foreground message received:', payload);

//     if (payload.notification?.title) {
//       try {
//         // // Only show toast notifications when app is in focus
//         // // If app is not in focus, let the service worker handle the notification
//         // const isAppInFocus = document.hasFocus();

//         // if (!isAppInFocus) {
//         //   console.log(
//         //     'App not in focus, letting service worker handle notification',
//         //   );
//         //   return; // Let the service worker handle the notification
//         // }

//         // console.log('App in focus, showing toast notification');

//         let notificationHandler: () => void = () => {};
//         switch (payload.data?.notificationType) {
//           case 'CHAT': {
//             notificationHandler = () => {
//               if (socketClient) {
//                 const chatId = payload.data?.chatId;
//                 if (chatId) {
//                   // Navigate to chats page - the socket will handle the active chat
//                   navigate(ROUTES.CHATS);
//                 }
//               }
//             };
//             break;
//           }
//           case 'ORDER': {
//             notificationHandler = () => {
//               navigate(
//                 `${
//                   payload.data?.orderId
//                     ? ROUTES.ORDERS_DETAILS.replace(
//                         ':id',
//                         payload.data?.orderId,
//                       )
//                     : ROUTES.ORDERS_LIST
//                 }`,
//               );
//             };
//             break;
//           }
//           default: {
//             break;
//           }
//         }

//         notify(
//           <ToastNotification
//             title={payload.notification?.title}
//             text={payload?.notification?.body || ''}
//             onClick={() => {
//               notificationHandler();
//             }}
//           />,
//           'success',
//         );
//       } catch (error) {
//         console.log(error);
//       }
//     } else {
//       console.log('no-title');
//     }
//   }

//   // Fix: Proper foreground message listener with useEffect
//   useEffect(() => {
//     if (!firebaseMessaging) {
//       console.log('Messaging not initialized, skipping foreground listener');
//       return;
//     }

//     console.log('Setting up foreground message listener...');

//     const unsubscribe = onMessage(firebaseMessaging, payload => {
//       console.log('Foreground message received:', payload);
//       handleMessage(payload as NotificationFCM);
//     });

//     // Cleanup function
//     return () => {
//       console.log('Cleaning up foreground message listener...');
//       unsubscribe();
//     };
//   }, [firebaseMessaging, socketClient, navigate]);

//   // Handle token refresh when user returns to the app
//   /**
//    * Handles the visibility change of the document to check and refresh the FCM token if necessary.
//    * Listens for changes in document visibility to trigger token validation.
//    * Updates and sends the refreshed FCM token to the backend if needed.
//    * Cleans up the event listener on component unmount.
//    */
//   useEffect(() => {
//     const handleVisibilityChange = async () => {
//       if (!document.hidden && token && firebaseMessaging) {
//         console.log('🔄 App became visible, checking token validity...');
//         try {
//           const currentToken = await getToken(firebaseMessaging, {
//             vapidKey: VAPID_KEY,
//           });

//           if (currentToken !== token) {
//             console.log('🔄 Token changed while app was hidden, updating...');
//             setToken(currentToken);

//             if (loginToken && apiStatus === ApiStatus.succeeded) {
//               await sendTokenToBackend(currentToken);
//             }
//           }
//         } catch (error) {
//           console.error('❌ Error checking token on visibility change:', error);
//         }
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
//   }, [token, firebaseMessaging, loginToken, apiStatus]);

//   // Get notification permission and FCM token
//   const getPermission = async (forceRefresh = false) => {
//     try {
//       console.log('🔐 Requesting notification permission...');
//       setHasTriedToGetToken(true); // Mark that we've tried to get token

//       // Check if notifications are supported
//       if (!('Notification' in window)) {
//         console.warn('⚠️ This browser does not support notifications');
//         return;
//       }

//       const permission = await Notification.requestPermission();
//       console.log('🔐 Permission result:', permission);

//       if (permission === 'granted') {
//         console.log('✅ Permission granted, getting FCM token...');

//         // Only generate token if we don't have one or force refresh is requested
//         if (firebaseMessaging && (!token || forceRefresh)) {
//           try {
//             console.log('🔄 Generating FCM token...');
//             const newToken = await getToken(firebaseMessaging, {
//               vapidKey: VAPID_KEY,
//             });
//             console.log(
//               '✅ FCM token generated:',
//               newToken ? 'Success' : 'Failed',
//             );

//             if (newToken) {
//               setToken(newToken);
//               console.log('💾 FCM token set in state');

//               // Always send token to backend if user is logged in
//               if (loginToken && apiStatus === ApiStatus.succeeded) {
//                 try {
//                   await sendTokenToBackend(newToken);
//                 } catch (error) {
//                   console.error('❌ Failed to send token to backend:', error);
//                 }
//               }
//             } else {
//               console.error('❌ Failed to get FCM token');
//             }
//           } catch (error) {
//             console.error('❌ Error generating FCM token:', error);
//             return;
//           }
//         } else if (token && !forceRefresh) {
//           console.log('✅ Already have FCM token, no need to regenerate');
//         }
//       } else if (permission === 'denied') {
//         console.warn('⚠️ Notification permission denied by user');
//         setToken('');
//       } else {
//         console.warn('⚠️ Notification permission default/unknown:', permission);
//       }
//     } catch (error) {
//       console.error('❌ Error in getPermission:', error);
//     }
//   };
//   // Register service worker and initialize notifications
//   useEffect(() => {
//     if (!isInitialized) return; // Wait for initialization to complete

//     console.log('🔧 Starting service worker registration...');
//     console.log('🔧 Browser support check:', {
//       hasServiceWorker: 'serviceWorker' in navigator,
//       isSafari: 'safari' in window,
//       hasPushManager: 'PushManager' in window,
//     });

//     if ('serviceWorker' in navigator && !('safari' in window)) {
//       // Check if service worker is already registered
//       navigator.serviceWorker.getRegistration().then(existingReg => {
//         if (existingReg) {
//           console.log('✅ Service worker already registered:', existingReg);
//           // Only get token if we haven't tried before and don't have one
//           if (existingReg.active && !hasTriedToGetToken && !token) {
//             console.log(
//               '✅ Service worker already active - getting token for first time',
//             );
//             setTimeout(() => {
//               getPermission();
//             }, 200);
//           } else if (existingReg.active && token) {
//             console.log(
//               '✅ Service worker active and we already have token - no need to regenerate',
//             );
//           }
//         } else {
//           // Register the service worker with correct path
//           console.log(
//             '🔧 Registering service worker at /firebase-messaging-sw.js',
//           );
//           navigator.serviceWorker
//             .register('/firebase-messaging-sw.js', {
//               scope: '/', // Use root scope for better compatibility
//             })
//             .then(reg => {
//               console.log('✅ Service worker registration successful:', reg);

//               // Handle service worker state
//               const handleServiceWorkerState = (sw: ServiceWorker) => {
//                 console.log('🔧 Service worker state:', sw.state);

//                 if (sw.state === 'activated') {
//                   console.log(
//                     '✅ Service worker activated - getting permission',
//                   );
//                   if ('PushManager' in window) {
//                     setTimeout(() => {
//                       getPermission();
//                     }, 200);
//                   } else {
//                     console.error('❌ Push messaging not supported');
//                   }
//                 }
//               };

//               // Check current service worker state
//               if (reg.installing) {
//                 handleServiceWorkerState(reg.installing);
//                 reg.installing.addEventListener('statechange', e => {
//                   handleServiceWorkerState(e.target as ServiceWorker);
//                 });
//               } else if (reg.waiting) {
//                 handleServiceWorkerState(reg.waiting);
//                 reg.waiting.addEventListener('statechange', e => {
//                   handleServiceWorkerState(e.target as ServiceWorker);
//                 });
//               } else if (reg.active) {
//                 handleServiceWorkerState(reg.active);
//               }
//             })
//             .catch(err => {
//               console.error('❌ Service worker registration failed:', err);
//             });
//         }
//       });
//     } else {
//       console.warn('⚠️ Service worker not supported or Safari detected');
//     }
//   }, [isInitialized, token, hasTriedToGetToken]);

//   // Send FCM token to backend when user logs in
//   useEffect(() => {
//     console.log('Login status check:', {
//       hasToken: !!token,
//       hasLoginToken: !!loginToken,
//       apiStatus,
//     });

//     // Send token to backend whenever user logs in and we have a token
//     if (loginToken && token && apiStatus === ApiStatus.succeeded) {
//       console.log('User logged in, sending FCM token to backend...');
//       sendTokenToBackend(token).catch(error => {
//         console.error('❌ Failed to send token to backend:', error);
//         // Retry after a delay
//         setTimeout(() => {
//           if (loginToken && token) {
//             console.log('🔄 Retrying token send...');
//             sendTokenToBackend(token).catch(retryError => {
//               console.error('❌ Retry failed:', retryError);
//             });
//           }
//         }, 5000);
//       });
//     }
//   }, [loginToken, token, apiStatus]);

//   // Periodic token validation and refresh
//   useEffect(() => {
//     if (!token || !firebaseMessaging) return;

//     // Check token validity every hour (tokens don't expire frequently)
//     const interval = setInterval(async () => {
//       try {
//         console.log('🔄 Periodic token validation...');
//         const currentToken = await getToken(firebaseMessaging, {
//           vapidKey: VAPID_KEY,
//         });

//         if (currentToken !== token) {
//           console.log('🔄 Token changed during periodic check, updating...');
//           setToken(currentToken);

//           if (loginToken && apiStatus === ApiStatus.succeeded) {
//             await sendTokenToBackend(currentToken);
//           }
//         } else {
//           console.log('✅ Token is still valid');
//         }
//       } catch (error) {
//         console.error('❌ Error during periodic token validation:', error);
//         // If token validation fails, try to refresh it
//         try {
//           console.log(
//             '🔄 Attempting to refresh token due to validation error...',
//           );
//           await getPermission(true);
//         } catch (refreshError) {
//           console.error('❌ Failed to refresh token:', refreshError);
//         }
//       }
//     }, 60 * 60 * 1000); // 1 hour

//     return () => clearInterval(interval);
//   }, [token, firebaseMessaging, loginToken, apiStatus]);

//   // Test function for debugging
//   const testNotification = () => {
//     console.log('🧪 Testing notification...');
//     if ('serviceWorker' in navigator) {
//       navigator.serviceWorker.ready.then(registration => {
//         registration.showNotification('Test Notification', {
//           body: 'This is a test notification',
//           icon: '/favicon.png',
//           badge: '/favicon.png',
//           tag: 'test-notification',
//         });
//         console.log('✅ Test notification sent');
//       });
//     }
//   };

//   // Force token refresh function for debugging
//   const forceTokenRefresh = () => {
//     console.log('🔄 Force refreshing FCM token...');
//     getPermission(true);
//   };

//   // Add test functions in development
//   useEffect(() => {
//     if (process.env.NODE_ENV === 'development') {
//       // Add test functions to window for debugging
//       (window as any).testNotification = testNotification;
//       (window as any).forceTokenRefresh = forceTokenRefresh;
//       (window as any).getCurrentToken = () => {
//         console.log('Current FCM token:', token);
//         return token;
//       };
//       console.log(
//         '🧪 Debug functions available:',
//         'window.testNotification()',
//         'window.forceTokenRefresh()',
//         'window.getCurrentToken()',
//       );
//     }
//   }, [token]);

//   return null;
// };
// export default NotificationService;

import { useEffect, useState } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { notify } from '../Utils/toastify';
import { NotificationFCM } from '../types';
import { ToastNotification } from './ToastNotification';
import { useSocket } from '../Pages/Chats/SocketContext';
import { ROUTES } from '../helpers/contants';
import { useNavigate } from 'react-router-dom';
import endPoints from '../api/endpoint';
import { putApiCall } from '../api/methods';
import { RootState, useAppSelector } from '../redux/store';
import { messaging } from '../Utils/firebaseConfig';
import { NOTIFICATION_TYPES } from '../Utils/constantData';
// import { getAndSetBranchAllList } from '../redux/common.slice';
const VAPID_KEY = process.env.FIREBASE_WEBPUSH_VAPID;

const NotificationService = () => {
  const [token, setToken] = useState<string>('');
  // const { userData, status } = useAppSelector((state: RootState) => state.auth);
  const { userData, token: loginToken } = useAppSelector(
    (state: RootState) => state.auth,
  );
  const socketClient = useSocket();
  const navigate = useNavigate();

  // console.log('messaging', messaging);

  // // const messaging = getMessaging(firebaseApp);
  // let messaging: any = null;
  // try {
  //   messaging = getMessaging(firebaseApp);
  // } catch (err) {
  //   console.error('Failed to initialize Firebase Messaging', err);
  // }

  // handle message
  function handleMessage(payload: NotificationFCM) {
    console.log('Foreground message received:', payload);

    // Handle new payload structure - data is in payload.data, not payload.notification
    if ((payload.data as any)?.title || payload.notification?.title) {
      try {
        // CRITICAL: Only show toast notifications when app is in focus
        // If app is not in focus, let the service worker handle the notification
        // const isAppInFocus = document.hasFocus();

        // if (!isAppInFocus) {
        //   console.log(
        //     'App not in focus, letting service worker handle notification',
        //   );
        //   return; // Let the service worker handle the notification
        // }

        console.log('App in focus, showing toast notification');
        // let notificationHandler: () => void = () => {};
        // switch (payload.data?.notificationType) {
        //   case 'CHAT': {
        //     notificationHandler = () => {
        //       if (socketClient) {
        //         const chatId = payload.data?.chatId;
        //         if (chatId) {
        //           socketClient.activeChat({ chatId });
        //           navigate(ROUTES.CHATS);
        //         }
        //       }
        //     };
        //     break;
        //   }
        //   case 'ORDER': {
        //     notificationHandler = () => {
        //       navigate(
        //         `${
        //           payload.data?.vendorOrderId
        //             ? ROUTES.ORDERS_DETAILS.replace(
        //                 ':id',
        //                 payload.data?.vendorOrderId,
        //               )
        //             : ROUTES.ORDERS
        //         }`,
        //       );
        //     };
        //     break;
        //   }
        //   case 'BOOKING_ALERT': {
        //     notificationHandler = () => {
        //       navigate(`${ROUTES.BOOK_CAB}`);
        //     };
        //     break;
        //   }
        //   default: {
        //     break;
        //   }
        // }

        // eslint-disable-next-line @typescript-eslint/no-empty-function
        let notificationHandler: () => void = () => {};
        switch (payload.data?.notificationType) {
          case 'CHAT': {
            notificationHandler = () => {
              if (socketClient) {
                const chatId = payload.data?.chatId;
                if (chatId) {
                  // Navigate to chats page - the socket will handle the active chat
                  navigate(ROUTES.CHATS);
                }
              }
            };
            break;
          }
          case 'ORDER': {
            notificationHandler = () => {
              if (
                payload?.data?.subNotificationType ===
                NOTIFICATION_TYPES.ORDER_REQUEST
              ) {
                navigate(
                  `${ROUTES.ORDERS_DETAILS.replace(
                    ':id',
                    payload?.data?.orderId,
                  )}?type=request&tabType=ORDER_REQUEST`,
                  { state: { fromNotification: true } },
                );
              } else if (
                payload?.data?.subNotificationType === 'VENDOR_ORDER_REQUEST'
              ) {
                navigate(
                  `${ROUTES.ORDERS_DETAILS.replace(
                    ':id',
                    payload?.data?.orderId,
                  )}?type=vendor&tabType=VENDOR_REQUEST`,
                  { state: { fromNotification: true } },
                );
              } else if (
                payload?.data?.orderId ||
                payload?.data?.vendorOrderId
              ) {
                navigate(
                  `${ROUTES.ORDERS_DETAILS.replace(
                    ':id',
                    payload?.data?.orderId || payload?.data?.vendorOrderId,
                  )}?type=list&tabType=MY_ORDERS`,
                  { state: { fromNotification: true } },
                );
              } else {
                window.location.href = `${ROUTES.ORDERS_LIST}`;
              }
              return;
            };
            break;
          }
          case 'PAYMENT': {
            notificationHandler = () => {
              navigate(ROUTES.PAYMENT_HISTORY);
            };
            break;
          }
          case 'INVOICE': {
            notificationHandler = () => {
              if (
                payload?.data?.subNotificationType ===
                'INVOICE_APPROVAL_PENDING'
              ) {
                navigate(`${ROUTES.INVOICE_REQUESTS}`);
              } else {
                navigate(`${ROUTES.INVOICE_DETAIL}/${payload?.data?.entityId}`);
              }
            };
            break;
          }
          case 'UpdateMemberPermission': {
            notificationHandler = () => {
              navigate(ROUTES.PROFILE);
            };
            break;
          }
          case 'SetCreation': {
            notificationHandler = () => {
              navigate(
                `${ROUTES.SET_DETAIL}/${payload.data?.notificationEntityId}`,
              );
            };
            break;
          }
          case 'LocationCreation': {
            notificationHandler = () => {
              navigate(
                `${ROUTES.LOCATION_DETAIL}/${payload.data?.notificationEntityId}`,
              );
            };
            break;
          }
          case 'ProductionCreation': {
            notificationHandler = () => {
              navigate(
                `${ROUTES.PRODUCTION_DETAIL}/${payload.data?.notificationEntityId}`,
              );
            };
            break;
          }
          case 'EpisodeCreation': {
            notificationHandler = () => {
              navigate(
                `${ROUTES.EPISODE_DETAIL}/${payload.data?.notificationEntityId}`,
              );
            };
            break;
          }
          default: {
            break;
          }
        }

        notify(
          <ToastNotification
            title={
              (payload.data as any)?.title || payload.notification?.title || ''
            }
            text={
              (payload.data as any)?.body || payload.notification?.body || ''
            }
            onClick={() => {
              notificationHandler();
            }}
          />,
          'success',
        );
      } catch (error) {
        console.log(error);
      }
      // dispatch(fetchNoticationList({ page: 1, pageSize: 5 }));
    } else {
      console.log('no-title');
    }
  }
  // // register function
  // new Promise(resolve => {
  //   messaging &&
  //     onMessage(messaging, payload => {
  //       resolve(payload);
  //     });
  // }).then(payload => {
  //   handleMessage(payload as NotificationFCM);
  // });

  useEffect(() => {
    if (!messaging) return;

    console.log('🔔 Setting up Firebase foreground message listeneer');

    const unsubscribe = onMessage(messaging, payload => {
      console.log('Foreground FCM message:', payload);
      handleMessage(payload as NotificationFCM);
    });

    return () => {
      console.log('🧹 Cleaning up foreground message listener');
      unsubscribe();
    };
  }, [messaging, socketClient, navigate]);

  // get notification permission
  const getPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      const token =
        messaging &&
        (await getToken(messaging, {
          vapidKey: VAPID_KEY,
        }));

      console.log('token', token);

      localStorage.setItem('tokenFCM', token);
      //We can send token to server
      setToken(token);
    } else if (permission === 'denied') {
      //notifications are blocked
      // console.log('You denied for the notification');
    }
  };
  // run on render
  useEffect(() => {
    if ('serviceWorker' in navigator && !('safari' in window)) {
      // Register the service worker as soon as the app loads
      // socpe
      navigator.serviceWorker
        .register('../../../firebase-messaging-sw.js', {
          scope: 'firebase-cloud-messaging-push-scope',
        })
        .then(reg => {
          let serviceWorker;
          if (reg.installing) {
            serviceWorker = reg.installing;
            // console.log('Service worker installing');
          } else if (reg.waiting) {
            serviceWorker = reg.waiting;
            // console.log('Service worker installed & waiting');
          } else if (reg.active) {
            serviceWorker = reg.active;
            // console.log('Service worker active');
          }

          if (serviceWorker) {
            console.log('sw: current state', serviceWorker.state);
            if (serviceWorker.state == 'activated') {
              //If push subscription wasnt done yet have to do here
              console.log('sw: already activated - Do watever needed here');
              getPermission();
            }
            serviceWorker.addEventListener('statechange', function (e: any) {
              console.log('sw: statechange : ', e.target.state);
              if (e.target.state == 'activated') {
                console.log(
                  'sw: Just now activated. now we can subscribe for push notification',
                );
                if (!('PushManager' in window)) {
                  console.log("sw: Push messaging isn't supported.");
                  return;
                }
                setTimeout(() => {
                  getPermission();
                }, 200);
              }
            });
          }
        })
        .catch(err => {
          console.log('sw: Service worker registration failed, error:', err);
        });
    }
  }, []);
  useEffect(() => {
    if (loginToken) {
      if (token) {
        // getAndSetBranchAllList();
        putApiCall(
          endPoints.notification.updateDeviceTokenFCM + `?token=${token}`,
          {},
          () => {
            console.log('token-added, now can receieve notificaiton');
          },
          () => {
            console.log('error-in updating notification');
          },
        );
      }
    }
  }, [loginToken, userData, token]);
  return null;
};
export default NotificationService;
